export const engagementAppGroupIdGetAccessibilityResultsId =
  "/engagement/:app_group_id/get_accessibility_results/:id";
